import React from 'react';
import { useIntl } from 'react-intl';
import { Swiper, SwiperSlide } from 'swiper/react';

import { AnimateInsertion } from '@/components/ui/AnimateInsertion';
import { useGeoDataMyIp } from '@/hooks/useGeoDataMyIp';
import { usePopularUpcomingDates } from '@/hooks/usePopularUpcomingDates';

import { SectionHeading } from '../../SectionHeading';
import { PopularCard } from './PopularCard';

export const PopularUpcomingDates = () => {
  const intl = useIntl();
  const geoData = useGeoDataMyIp();
  const { data: popularUpcomingDates, error } = usePopularUpcomingDates();

  const address = geoData.data ? `${geoData.data.city}, ${geoData.data.state}` : '';

  if (!popularUpcomingDates || error) return null;

  return (
    <AnimateInsertion>
      <div className="flex flex-col mb-10 gap-4 lg:gap-6 lg:mb-20">
        <SectionHeading
          text={intl.formatMessage({
            defaultMessage: 'Popular upcoming dates',
            id: 'mkf72Y',
          })}
        />
        <div className="justify-between hidden lg:grid gap-6 grid-cols-3">
          {popularUpcomingDates.map(date => (
            <PopularCard key={date.title} {...date} address={address} />
          ))}
        </div>
        <div className="-mx-6 lg:hidden">
          <Swiper slidesPerView={1.1} spaceBetween={16} centeredSlides>
            {popularUpcomingDates.map(date => (
              <SwiperSlide key={date.title}>
                <PopularCard {...date} address={address} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </AnimateInsertion>
  );
};
